<template>
  <!-- 261026 오전 대표 회의 ⑦ "옛날 커피 이벤트처럼 앱 열면 주차 QR 할인 판매 창을 올려라" · "받아도 파는 물건인 걸 알게".
       문구 A(정가 취소선 → 할인가 — 261027 유저 확정, 홈 주차 QR 칸과 같은 값). 홈(ServiceLanding)이 앱을 켤 때 한 번 띄운다. 틀 = QrPreOrderSheet.
       261104 유저 시안(행사 팝업 — "문구랑 디자인 이렇게") — 배지 · '안심 주차 QR' · 행사 스티커 · 정가/행사가/할인 칩 · '{가격}에 구매하기' · '내 등록차량 보기'(꾸밈 = 코덱스 외주). -->
  <div class="modal-dim on ps-dim">
    <div class="ps-sheet-wrap" @click.self="emits('close')">
      <div class="ps-sheet modal" role="dialog" aria-labelledby="ps-sheet-title">
        <button type="button" class="ps-sheet__x" aria-label="닫기" @click="emits('close')">×</button>
        <p class="ps-sheet__badge">간판ON 공식 판매상품</p>
        <p id="ps-sheet-title" class="ps-sheet__title">안심 주차 QR</p>
        <p class="ps-sheet__subtitle">지금, 특별한 행사가로 만나보세요</p>
        <div class="ps-sheet__media">
          <img class="ps-sheet__photo" :src="imgParkingSale" width="1470" height="565" alt="차 앞 유리 안쪽 대시보드에 세운 투명 아크릴 주차 QR">
          <span class="ps-sheet__sticker">
            <svg class="ps-sheet__seal" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
              <path d="M50 3 C55 3 57 8 62 9 S71 7 75 10 S78 18 82 21 S91 23 93 28 S92 37 94 42 S99 50 97 55 S91 61 90 66 S91 75 87 79 S78 80 74 84 S70 93 65 94 S56 92 51 94 S42 98 37 95 S32 88 27 87 S18 87 15 82 S14 73 11 69 S4 63 4 58 S8 50 7 45 S3 36 6 32 S13 27 15 23 S16 14 21 12 S30 13 34 10 S45 3 50 3 Z" />
            </svg>
            <span class="ps-sheet__sticker-text">행사<br>판매 중</span>
            <svg class="ps-sheet__spark" viewBox="0 0 28 24" aria-hidden="true" focusable="false">
              <path d="M6 12 10 3 M15 17 24 10" />
            </svg>
          </span>
        </div>
        <p class="ps-sheet__lead">전화번호 대신 QR로 간편하게 연락받으세요</p>
        <p class="ps-sheet__price">
          <s class="ps-sheet__price-list">정가 {{ PARKING_PRICE.list }}</s>
          <span class="ps-sheet__offer">
            <span class="ps-sheet__price-label">행사가</span>
            <strong class="ps-sheet__price-now">{{ PARKING_PRICE.now }}</strong>
          </span>
          <span class="ps-sheet__discount">{{ PARKING_PRICE.off }} 할인</span>
        </p>
        <!-- .stop — 클릭이 창 뿌리의 '바깥 누르면 닫기'(views/index.vue modalOutSideEvent)까지 가면 방금 연 신청 창을 닫는다(261027 테섭 E2E) -->
        <button type="button" class="ps-sheet__cta" @click.stop="fnAsk">{{ PARKING_PRICE.now }}에 구매하기 <span class="ps-sheet__arrow" aria-hidden="true">→</span></button>
        <div class="ps-sheet__owned">
          <span class="ps-sheet__owned-label">이미 제품이 있으신가요?</span>
          <button type="button" class="ps-sheet__mine" @click.stop="fnMyCars">내 등록차량 보기</button>
        </div>
        <div class="ps-sheet__foot">
          <button type="button" class="ps-sheet__hide" @click="fnHideToday">오늘 하루 보지 않기</button>
          <button type="button" class="ps-sheet__close" @click="emits('close')">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import router from '@/router';
import { openSmartStore } from '@/common/utils/smartStore';
import { PARKING_PRICE, PARKING_SALE_HIDE_KEY, localDay } from '@/common/utils/parkingSale.mjs';
// 261104 유저 '주차QR 이미지는 우리 가장 최근 걸로' — 같은 대시보드 사진에 v5L 판(주차중입니다 + QR 가운데 로고, 사진 속 QR = ganpanon.com)을 합성하고
//   가로 칸(약 2.5:1)에 판이 잘리지 않게 양옆 배경을 늘린 그림(1470×565). 홈 주차 QR 칸 사진(parking-card-photo.jpg, 950×565)도 같은 v5L 합성으로 바꿈(유저 '메인 사진도 이걸로').
import imgParkingSale from '@/assets/static/images/qr/parking/parking-sale-photo.jpg';

const emits = defineEmits(['close']);

// 홈 주차 QR 칸 버튼과 같은 신청 창(스토어 열기 전엔 사전 신청) — entry 로 이 창에서 온 걸 남긴다
const fnAsk = () => {
  emits('close');
  openSmartStore({ entry: 'popup-parking', product: '주차 QR' });
};

// 261104 유저 시안 '이미 제품이 있으신가요? 내 등록차량 보기' — 마이 '내 등록차량'과 같은 곳(/parking).
//   로그인 전이면 그 화면 가드가 로그인으로 보냈다가 돌아오게 하고, 판이 없으면 그 화면이 등록 화면으로 바꿔 보낸다.
const fnMyCars = () => {
  emits('close');
  router.push('/parking');
};

const fnHideToday = () => {
  try { localStorage.setItem(PARKING_SALE_HIDE_KEY, localDay()); } catch { /* noop */ }
  emits('close');
};
</script>

<style scoped>
/* 홈 머리띠(.gp-site-header z 40) 위 — 전역 .modal-dim(20)만으론 머리띠가 어두운 막 위에 남아 눌린다. 홈 안 창(공유·영상 60↑)보단 아래 */
.ps-dim { z-index: 50; }
.ps-sheet-wrap { position: absolute; inset: 0; z-index: 1; display: flex; align-items: flex-end; justify-content: center; }
.ps-sheet.modal {
  --ps-blue: #003EDA;
  --ps-ink: #0B1220;
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100%; min-width: 0; max-width: 600px; max-height: 90%;
  overflow-y: auto; overscroll-behavior-y: contain;
  padding: 24px 20px calc(8px + env(safe-area-inset-bottom));
  border-radius: 24px 24px 0 0; background: #fff;
  box-shadow: 0 -8px 32px rgba(15, 31, 61, .12);
  color: var(--ps-ink); font-family: 'Pretendard', system-ui, -apple-system, sans-serif;
  font-size: 16px; line-height: 1.5; letter-spacing: -0.02em; text-align: left;
  word-break: keep-all; overflow-wrap: break-word;
  animation: psSheetUp .3s ease;
}
@keyframes psSheetUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
.ps-sheet__x { position: absolute; top: 10px; right: 12px; width: auto; min-width: 48px; height: 48px; padding: 0; border: 0; background: none; color: #768191; font-family: inherit; font-size: 32px; font-weight: 300; line-height: 1; cursor: pointer; }
.ps-sheet__badge { display: inline-block; max-width: calc(100% - 48px); margin: 0; padding: 6px 12px; border-radius: 9px; background: var(--ps-blue); color: #fff; font-size: 16px; font-weight: 800; line-height: 1.4; }
.ps-sheet__title { margin: 10px 0 4px; color: var(--ps-ink); font-size: 32px; font-weight: 900; line-height: 1.2; letter-spacing: -0.03em; white-space: nowrap; }
.ps-sheet__subtitle { margin: 0; color: var(--ps-blue); font-size: 20px; font-weight: 800; line-height: 1.4; word-break: keep-all; }
.ps-sheet__media { position: relative; margin: 24px 0 12px; }
/* 판 위아래를 보존하도록 높이 제한 없이 5:2 비율로 함께 축소한다. */
.ps-sheet__photo { display: block; width: 100%; height: auto; aspect-ratio: 5 / 2; object-fit: cover; object-position: center; border-radius: 16px; }
.ps-sheet__sticker { position: absolute; top: -12px; right: 16px; display: flex; align-items: center; justify-content: center; width: 88px; height: 88px; color: #fff; text-align: center; pointer-events: none; }
.ps-sheet__seal { position: absolute; inset: 0; width: 100%; height: 100%; fill: var(--ps-blue); stroke: #fff; stroke-width: 2; }
.ps-sheet__sticker-text { position: relative; font-size: 20px; font-weight: 800; line-height: 1.15; }
.ps-sheet__spark { position: absolute; top: -9px; right: -6px; width: 28px; height: 24px; fill: none; stroke: var(--ps-blue); stroke-width: 3; stroke-linecap: round; }
.ps-sheet__lead { margin: 0 0 14px; color: var(--ps-ink); font-size: 17px; font-weight: 650; line-height: 1.5; text-align: center; }
.ps-sheet__price { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 8px 12px; margin: 0 0 18px; }
.ps-sheet__price-list { display: inline-flex; align-items: center; gap: 12px; color: #626871; font-size: 16px; line-height: 1.5; white-space: nowrap; }
.ps-sheet__price-list::after { content: ''; width: 1px; height: 22px; background: #A0A4AE; }
.ps-sheet__offer { display: inline-flex; align-items: center; justify-content: center; gap: 8px; white-space: nowrap; }
.ps-sheet__price-label { padding: 4px 8px; border-radius: 8px; background: var(--ps-blue); color: #fff; font-size: 15px; font-weight: 800; line-height: 1.4; }
.ps-sheet__price-now { color: var(--ps-blue); font-size: 34px; font-weight: 900; line-height: 1.2; white-space: nowrap; }
.ps-sheet__discount { padding: 4px 10px; border-radius: 9px; background: #D4E5FE; color: var(--ps-blue); font-size: 15px; font-weight: 800; line-height: 1.4; white-space: nowrap; }
.ps-sheet__cta { display: flex; align-items: center; justify-content: center; gap: 12px; width: 100%; min-height: 56px; padding: 12px 16px; border: 0; border-radius: 12px; background: var(--ps-blue); color: #fff; font-family: inherit; font-size: 20px; font-weight: 800; line-height: 1.4; cursor: pointer; }
.ps-sheet__arrow { font-size: 26px; line-height: 1; }
.ps-sheet__owned { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 0 6px; margin-top: 8px; font-size: 16px; }
.ps-sheet__owned-label { color: #5C6577; }
/* jump-user 전역 button{width:100%}을 글자 폭 버튼에서 해제한다. */
.ps-sheet__mine { width: auto; min-height: 48px; padding: 8px 0; border: 0; background: none; color: var(--ps-blue); font-family: inherit; font-size: 16px; font-weight: 800; line-height: 1.4; text-decoration: underline; text-decoration-color: #5779DF; text-underline-offset: 4px; cursor: pointer; }
.ps-sheet__foot { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 8px; }
.ps-sheet__hide, .ps-sheet__close { width: auto; min-width: 48px; min-height: 48px; padding: 8px 4px; border: 0; background: none; font-family: inherit; font-size: 16px; line-height: 1.4; cursor: pointer; }
.ps-sheet__hide { color: #626871; }
.ps-sheet__close { color: var(--ps-ink); font-weight: 800; }
.ps-sheet__cta:focus-visible, .ps-sheet__mine:focus-visible, .ps-sheet__hide:focus-visible, .ps-sheet__close:focus-visible, .ps-sheet__x:focus-visible { outline: 3px solid var(--ps-ink); outline-offset: 2px; }
.ps-sheet__cta:active, .ps-sheet__mine:active, .ps-sheet__hide:active, .ps-sheet__close:active, .ps-sheet__x:active { filter: brightness(.85); }
/* 휴대폰에서는 정가·할인 칩 / 행사가·가격을 각각 한 묶음으로 읽는다. */
@media (max-width: 479px) {
  .ps-sheet__price { display: grid; grid-template-columns: auto auto; gap: 6px 12px; }
  .ps-sheet__price-list { grid-column: 1; grid-row: 1; }
  .ps-sheet__discount { grid-column: 2; grid-row: 1; }
  .ps-sheet__offer { grid-column: 1 / -1; grid-row: 2; }
}
@media (max-width: 374px) { .ps-sheet.modal { padding-right: 16px; padding-left: 16px; } }
/* 짧은 화면은 간격만 줄인다. 글자·버튼 크기와 사진 비율은 유지한다. */
@media (max-height: 700px) {
  .ps-sheet.modal { padding-top: 16px; }
  .ps-sheet__badge { padding-top: 5px; padding-bottom: 5px; }
  .ps-sheet__title { margin-top: 8px; margin-bottom: 2px; }
  .ps-sheet__media { margin-top: 20px; margin-bottom: 10px; }
  .ps-sheet__lead { margin-bottom: 10px; }
  .ps-sheet__price { margin-bottom: 10px; }
  .ps-sheet__owned { margin-top: 4px; }
  .ps-sheet__foot { margin-top: 0; }
}
@media (prefers-reduced-motion: reduce) { .ps-sheet.modal { animation: none; } }
</style>
